import instance from '../instance';
import getLiveElement from '../accessors/get-live-element';
import prepareSerializedStaticDocument from '../utils/helpers/prepare-serialized-static-document';

const replaceElement = (element, targetElementId, updateStrategy) => {
  const targetElement = getLiveElement(targetElementId);
  instance.driver.replaceElement(element, targetElement, updateStrategy);
  const clonedStaticDOM = instance.driver.getStaticDocument().cloneNode(true);

  return prepareSerializedStaticDocument(clonedStaticDOM);
};

export default replaceElement;
